import type { ErrorInfo, ErrorMessageIf } from '@/utils/globalError/entities/valueObjects/types'
import { ERROR_CODES } from './errorCode'

const defaultErrorObject: ErrorInfo = {
  message: '',
  needsSupport: false,
  note: '',
  title: ''
}

/**
 * 画面コード一覧
 */
export enum ViewCode {
  // 調査計画一覧画面
  INSPECTION_PLAN = '12'
}

export const ERROR_MESSAGES: ErrorMessageIf = {
  /* 複数画面共通　*/
  [ERROR_CODES.COMMON_PHOTO_LIMIT_EXCEEDED]: {
    ...defaultErrorObject,
    message: '写真登録枚数が上限に達しています。'
  },
  [ERROR_CODES.COMMON_BUILDING_GET_FAILED]: {
    ...defaultErrorObject,
    message: '建物情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.COMMON_DEVICE_GET_ARG_INVALID]: {
    ...defaultErrorObject,
    message: 'リクエストの型が不正です。',
    title: 'エラー'
  },
  [ERROR_CODES.COMMON_DEVICE_ACTIVATION_ARG_INVALID]: {
    ...defaultErrorObject,
    message: 'リクエストの型が不正です。',
    title: 'エラー'
  },
  [ERROR_CODES.COMMON_DEVICE_UPDATE_ARG_INVALID]: {
    ...defaultErrorObject,
    message: 'リクエストの型が不正です。',
    title: 'エラー'
  },
  [ERROR_CODES.COMMON_READ_FILE_FAILED]: {
    ...defaultErrorObject,
    message: 'ファイルの読み込みに失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.COMMON_LABEL_GET_FAILED]: {
    ...defaultErrorObject,
    message: 'ラベルの取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.COMMON_MAP_NOT_FOUND]: {
    ...defaultErrorObject,
    message: '対象の建築物情報が取得できませんでした。',
    title: 'エラー'
  },

  /* ログイン画面 */
  [ERROR_CODES.LOGIN_DEVICE_GET_FAILED]: {
    ...defaultErrorObject,
    message: 'デバイス認証情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.LOGIN_GOVERNMENT_SETTINGS_GET_FAILED]: {
    ...defaultErrorObject,
    message: '自治体設定情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.LOGIN_DISASTER_GET_FAILED]: {
    ...defaultErrorObject,
    message: '災害情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.LOGIN_GOVERNMENT_SETTINGS_EMPTY]: {
    ...defaultErrorObject,
    message: '不正な自治体設定情報です。',
    title: 'エラー'
  },
  [ERROR_CODES.LOGIN_AUTH_GET_FAILED]: {
    ...defaultErrorObject,
    message: 'ログイン認証に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.LOGIN_AUTHZ_DENIED]: {
    ...defaultErrorObject,
    message: 'このアカウントはログインするための権限がありません。',
    title: 'エラー'
  },

  /* デバイス登録画面 */
  [ERROR_CODES.DEVICE_REGISTER_DEVICE_ACTIVATION_FAILED]: {
    ...defaultErrorObject,
    message: 'デバイスアクティベーションの実行に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.DEVICE_REGISTER_DEVICE_UPDATE_FAILED]: {
    ...defaultErrorObject,
    message: 'デバイス情報の更新に失敗しました。',
    title: 'エラー'
  },
  // APIレスポンス
  [ERROR_CODES.DEVICE_REGISTER_EXPIRED]: {
    ...defaultErrorObject,
    message: '有効期限の切れていない2次元コードを読み取り、再度登録を実施してください。',
    title: '有効期限が切れています'
  },
  [ERROR_CODES.DEVICE_REGISTER_ALREADY_USED]: {
    ...defaultErrorObject,
    message: '新たに生成した2次元コードを読み取り、再度登録を実施してください。',
    title: '既に別のデバイスで利用されている2次元コードです'
  },

  /* ホーム画面 */
  [ERROR_CODES.HOME_INSPECTION_RESULT_GET_FAILED]: {
    ...defaultErrorObject,
    message: '調査実施結果情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.HOME_ADMIN_DISTRICTS_GET_FAILED]: {
    ...defaultErrorObject,
    message: '行政区画情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.HOME_DISASTER_GET_FAILED]: {
    ...defaultErrorObject,
    message: '災害情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.HOME_DISASTER_ID_NOT_EXIST]: {
    ...defaultErrorObject,
    message: '災害情報が存在しません。',
    title: 'エラー'
  },
  [ERROR_CODES.HOME_GOV_CODE_NOT_EXIST]: {
    ...defaultErrorObject,
    message: '自治体情報が存在しません。',
    title: 'エラー'
  },
  [ERROR_CODES.HOME_TARGET_INSPECTION_NOT_FOUND]: {
    ...defaultErrorObject,
    message: '選択された判定済家屋の調査情報がみつかりませんでした。',
    title: 'エラー'
  },

  /* 調査員登録画面 */
  // なし

  /* 建物概要画面 */
  [ERROR_CODES.BUILDING_OVERVIEW_NOT_SPECIFIED]: {
    ...defaultErrorObject,
    message: '建物を選択してください。'
  },
  [ERROR_CODES.BUILDING_OVERVIEW_ADMIN_DISTRICTS_GET_FAILED]: {
    ...defaultErrorObject,
    message: '行政区画情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.BUILDING_OVERVIEW_NOT_APPLICABLE]: {
    ...defaultErrorObject,
    message: '対象地域の範囲外が選択されました。再度選択してください。'
  },
  [ERROR_CODES.BUILDING_OVERVIEW_TARGET_BUILDING_NOT_FOUND]: {
    ...defaultErrorObject,
    message: '編集中の調査に建物情報のデータがありません。'
  },

  /* step1画面 */
  // なし

  /* step2画面 */
  [ERROR_CODES.STEP2_ALL_UNSELECTED]: {
    ...defaultErrorObject,
    message: '全ての調査項目が未選択のため、判定できません。'
  },
  [ERROR_CODES.STEP2_STRING_CONVERSION_FAILED]: {
    ...defaultErrorObject,
    message: '文字列を正しく変換できませんでした。'
  },
  [ERROR_CODES.STEP2_CONSTRUCTION_TYPE_UNSELECTED]: {
    ...defaultErrorObject,
    message: '家屋構造種別が選択されていません。'
  },

  /* 判定結果画面 */
  [ERROR_CODES.RESULT_TEXT_LIMIT_OVER]: {
    ...defaultErrorObject,
    message: 'コメントは300文字以内で記入してください。'
  },
  [ERROR_CODES.RESULT_PHOTO_LIMIT_EXCEEDED]: {
    ...defaultErrorObject,
    message: '写真登録枚数が上限に達しています。'
  },
  [ERROR_CODES.RESULT_SAVE_FAILED]: {
    ...defaultErrorObject,
    message: '調査実施結果の登録に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.RESULT_PROPERTY_INVALID]: {
    ...defaultErrorObject,
    message: '調査実施結果の登録に失敗しました。プロパティが不正です。',
    title: 'エラー'
  },

  /* 地図ダウンロード画面 */
  [ERROR_CODES.MAP_DOWNLOAD_ADMIN_DISTRICTS_GET_FAILED]: {
    ...defaultErrorObject,
    message: '行政区画情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.MAP_DOWNLOAD_BUILDING_GET_FAILED]: {
    ...defaultErrorObject,
    message: '建物情報の取得に失敗しました。',
    title: 'エラー'
  },

  /* zipダウンロード */
  [ERROR_CODES.ZIP_CREATE_ERROR]: {
    ...defaultErrorObject,
    message: 'zipファイルのダウンロードに失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.ZIP_DOWNLOAD_ERROR]: {
    ...defaultErrorObject,
    message: 'zipファイルのダウンロードに失敗しました。',
    title: 'エラー'
  }
}
